/**
 * Single enum files to consolidate all platform intents
 * used across different projects and packages
 */

enum TransferIntent {
  DEPOSIT_DIGITAL = 'DEPOSIT_DIGITAL',
  WITHDRAW_FIAT = 'WITHDRAW_FIAT',
  WITHDRAW_DIGITAL = 'WITHDRAW_DIGITAL',
  DEPOSIT_FIAT = 'DEPOSIT_FIAT',
  COMMODITIES_DEPOSIT = 'COMMODITIES_DEPOSIT',
  COMMODITIES_WITHDRAW = 'COMMODITIES_WITHDRAW',
  EXCHANGE = 'EXCHANGE',
  REPAYMENT_EXCHANGE = 'REPAYMENT_EXCHANGE',
  BILL_PAYMENT = 'BILL_PAYMENT',
  TRANSFER_SELF = 'TRANSFER_SELF',
  TRANSFER_P2P = 'TRANSFER_P2P',
  TRADER_MINT = 'TRADER_MINT',
  TRADER_BURN = 'TRADER_BURN',
  GENERAL_INSTRUCTION = 'GENERAL_INSTRUCTION',
  BORROW = 'BORROW',
  REPAY = 'REPAY',
  INTEREST = 'INTEREST',
  FEE_PAYOUT = 'FEE_PAYOUT',
  FEE = 'FEE',
  EARN_SUBSCRIPTION = 'EARN_SUBSCRIPTION',
  EARN_REDEMPTION = 'EARN_REDEMPTION',
  EARN_REDEMPTION_FEE = 'EARN_REDEMPTION_FEE',
  EARN_REWARD = 'EARN_REWARD',
  CARD_TOPUP = 'CARD_TOPUP',
  CARD_WITHDRAW = 'CARD_WITHDRAW',
  CARD_BORROW = 'CARD_BORROW',
  SETTLEMENT = 'SETTLEMENT'
}

enum GeneralInstructionIntent {
  ACCOUNT_ADMIN_FEE = 'ACCOUNT_ADMIN_FEE',
  ACCOUNT_ADMIN_FEE_REBATE = 'ACCOUNT_ADMIN_FEE_REBATE',
  ACCOUNT_SETUP_FEE = 'ACCOUNT_SETUP_FEE',
  INTRA_ACCOUNT_INJECTION_FEE = 'INTRA_ACCOUNT_INJECTION_FEE',
  ADJUSTMENT = 'ADJUSTMENT',
  ASSET_INJECTION = 'ASSET_INJECTION',
  ASSET_WITHDRAWAL = 'ASSET_WITHDRAWAL',
  BILL_PAYMENT = 'BILL_PAYMENT',
  BOND_OPEN_ACCOUNT = 'BOND_OPEN_ACCOUNT',
  BOND_REDEMPTION = 'BOND_REDEMPTION',
  BOND_SUBSCRIPTION = 'BOND_SUBSCRIPTION',
  CARD_PAYMENT = 'CARD_PAYMENT',
  CHANGE_BENEFICIARIES = 'CHANGE_BENEFICIARIES',
  CHARGE = 'CHARGE',
  CLIENT_INVOICE = 'CLIENT_INVOICE',
  COMMISSION = 'COMMISSION',
  COMMODITIES = 'COMMODITIES',
  EARN_FEE = 'EARN_FEE',
  EARN_REDEMPTION = 'EARN_REDEMPTION',
  EARN_REDEMPTION_FEE = 'EARN_REDEMPTION_FEE',
  EARN_SUBSCRIPTION = 'EARN_SUBSCRIPTION',
  EARN_REWARD = 'EARN_REWARD',
  EXCHANGE_SUB_ACCOUNT_APPLICATION = 'EXCHANGE_SUB_ACCOUNT_APPLICATION',
  EXCHANGE_SUB_ACCOUNT_MONTHLY_FEE = 'EXCHANGE_SUB_ACCOUNT_MONTHLY_FEE',
  EXCHANGE_SUB_ACCOUNT_TRANSFER = 'EXCHANGE_SUB_ACCOUNT_TRANSFER',
  FEE = 'FEE',
  FOREX = 'FOREX',
  FUND_OPEN_ACCOUNT = 'FUND_OPEN_ACCOUNT',
  FUND_REDEMPTION = 'FUND_REDEMPTION',
  FUND_SUBSCRIPTION = 'FUND_SUBSCRIPTION',
  INSURANCE_ENQUIRY = 'INSURANCE_ENQUIRY',
  INSURANCE = 'INSURANCE',
  OTHER = 'OTHER',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  SECURITIES_APPLICATION = 'SECURITIES_APPLICATION',
  SECURITIES_TRANSFER = 'SECURITIES_TRANSFER',
  SELECTED_GLOBAL_MARKET_DATA_SERVICES = 'SELECTED_GLOBAL_MARKET_DATA_SERVICES',
  SETTLEMENT = 'SETTLEMENT',
  TRANSFER = 'TRANSFER',
  FUND_DISTRIBUTION = 'FUND_DISTRIBUTION',
  REMITTANCE = 'REMITTANCE',
  NFT_CUSTODY_SERVICE_FEE = 'NFT_CUSTODY_SERVICE_FEE',
  FUND_TRANSFER = 'FUND_TRANSFER',
  BOND_TRANSFER = 'BOND_TRANSFER',
  CARD_APPLICATION_FEE = 'CARD_APPLICATION_FEE',
  STATIC_VIRTUAL_ACCOUNT_OPENING = 'STATIC_VIRTUAL_ACCOUNT_OPENING',
  ACCOUNT_INJECTION_FEE = 'ACCOUNT_INJECTION_FEE',
  CARD_ACCOUNT_MANAGEMENT = 'CARD_ACCOUNT_MANAGEMENT',
  UNIP_SALES = 'UNIP_SALES',
  FEE_SPLIT = 'FEE_SPLIT',
  ACCOUNT_APPLICATION = 'ACCOUNT_APPLICATION',
  ACCOUNT_APPLICATION_FEE = 'ACCOUNT_APPLICATION_FEE',
  ACCOUNT_MONTHLY_FEE = 'ACCOUNT_MONTHLY_FEE',
  AUDIT_CONFIRMATION_FEE = 'AUDIT_CONFIRMATION_FEE',
  STORAGE_FEE = 'STORAGE_FEE',
  SCHEDULER = 'SCHEDULER',
  PROFIT_SHARING = 'PROFIT_SHARING',
  CARD_REPLACEMENT_FEE = 'CARD_REPLACEMENT_FEE',
  MANAGE_AUTOPAY = 'MANAGE_AUTOPAY',
  DIGITAL_ASSET_RECOVERY_INSTRUCTION_FEE = 'DIGITAL_ASSET_RECOVERY_INSTRUCTION_FEE',
  DIGITAL_ASSET_RECOVERY_FEE = 'DIGITAL_ASSET_RECOVERY_FEE',
  // System instruction for clearing the revenue transfers
  FEE_PAYOUT = 'FEE_PAYOUT',
  PRECIOUS_METAL_BUY = 'PRECIOUS_METAL_BUY',
  PRECIOUS_METAL_SELL = 'PRECIOUS_METAL_SELL',
  PRECIOUS_METAL_WITHDRAWAL = 'PRECIOUS_METAL_WITHDRAWAL',
  // IFAST Fund
  IFAST_FUND_SUBSCRIPTION = 'IFAST_FUND_SUBSCRIPTION',
  IFAST_FUND_REDEMPTION = 'IFAST_FUND_REDEMPTION',
  IFAST_FUND_OPEN_ACCOUNT = 'IFAST_FUND_OPEN_ACCOUNT',
  IFAST_FUND_DIVIDEND_PAYOUT = 'IFAST_FUND_DIVIDEND_PAYOUT',
  // For cobrand fee charge via GI
  COBRAND_SETUP_FEE = 'COBRAND_SETUP_FEE',
  COBRAND_API_SOLUTION_SETUP_FEE = 'COBRAND_API_SOLUTION_SETUP_FEE',
  COBRAND_API_SOLUTION_ANNUAL_MAINTENANCE_FEE = 'COBRAND_API_SOLUTION_ANNUAL_MAINTENANCE_FEE',
  COBRAND_CUSTODIAL_DEED_SETUP_FEE = 'COBRAND_CUSTODIAL_DEED_SETUP_FEE',
  COBRAND_CUSTODIAL_ANNUAL_MAINTENANCE_FEE = 'COBRAND_CUSTODIAL_ANNUAL_MAINTENANCE_FEE',
  COBRAND_PHYSICAL_CARD_FEE = 'COBRAND_PHYSICAL_CARD_FEE',
  COBRAND_CARD_DESIGN_APPROVAL_FEE = 'COBRAND_CARD_DESIGN_APPROVAL_FEE',
  COBRAND_GOOGLE_PAY_INTEGRATION_FEE = 'COBRAND_GOOGLE_PAY_INTEGRATION_FEE',
  COBRAND_GOOGLE_PAY_ANNUAL_MAINTAINENCE_FEE = 'COBRAND_GOOGLE_PAY_ANNUAL_MAINTAINENCE_FEE'
}

enum TrustServiceIntent {
  BANK_CHARGE = 'BANK_CHARGE',
  SERVICE_CHARGE = 'SERVICE_CHARGE',
  ACCOUNT_SETUP_FEE = 'ACCOUNT_SETUP_FEE',
  ACCOUNT_MANAGEMENT_FEE = 'ACCOUNT_MANAGEMENT_FEE',
  ACCOUNT_APPLICATION_FEE = 'ACCOUNT_APPLICATION_FEE',
  ACCOUNT_MONTHLY_FEE = 'ACCOUNT_MONTHLY_FEE',
  ADDITIONAL_CARD_APPLICATION_FEE = 'ADDITIONAL_CARD_APPLICATION_FEE',
  THIRD_PARTY_BANK_DEPOSIT_WHITELIST_FEE = 'THIRD_PARTY_BANK_DEPOSIT_WHITELIST',
  THIRD_PARTY_INJECTION_VIA_BANKING_TOOLS_FEE = 'THIRD_PARTY_INJECTION_VIA_BANKING_TOOLS',
  NFT_INSTRUCTION_FEE = 'NFT_INSTRUCTION_FEE',
  NFT_CUSTODY_SERVICE_FEE = 'NFT_CUSTODY_SERVICE_FEE',
  DEPOSIT_WALLET_ADDRESS_REPLACEMENT_FEE = 'DEPOSIT_WALLET_ADDRESS_REPLACEMENT_FEE',
  REJECTED_DIGITAL_ASSET_TRANSACTION_SERVICE_FEE = 'REJECTED_DIGITAL_ASSET_TRANSACTION_SERVICE_FEE',
  ELECTRONIC_CASHIER_ORDER_PAYOUT = 'ELECTRONIC_CASHIER_ORDER_PAYOUT',
  PHYSICAL_CASHIER_ORDER_PAYOUT = 'PHYSICAL_CASHIER_ORDER_PAYOUT',
  STOP_CHEQUE_SERVICE_FEE = 'STOP_CHEQUE_SERVICE_FEE',
  STOP_CASHIER_ORDER_SERVICE_FEE = 'STOP_CASHIER_ORDER_SERVICE_FEE',
  PAYMENT_AMENDMENT_CANCELLATION_FEE = 'PAYMENT_AMENDMENT_CANCELLATION_FEE',
  PAYMENT_TO_PAYROLL = 'PAYMENT_TO_PAYROLL',
  SECURE_LOGISTICS_WITH_SECURITY_TRUCK = 'SECURE_LOGISTICS_WITH_SECURITY_TRUCK',
  ACCOUNT_INJECTION_FEE = 'ACCOUNT_INJECTION_FEE',
  SECURITIES_ACCOUNT_MONTHLY_FEE = 'SECURITIES_ACCOUNT_MONTHLY_FEE'
}

enum CardAccountIntent {
  CARD_APPLICATION_FEE = 'CARD_APPLICATION_FEE',
  CARD_ANNUAL_FEE = 'CARD_ANNUAL_FEE',
  CARD_RENEWAL_FEE = 'CARD_RENEWAL_FEE',
  CARD_CANCELLATION_FEE = 'CARD_CANCELLATION_FEE',
  CARD_REPLACEMENT_FEE = 'CARD_REPLACEMENT_FEE',
  CARD_MAILING_FEE = 'CARD_MAILING_FEE',
  CARD_DORMANT_FEE = 'CARD_DORMANT_FEE',
  CARD_LONG_DORMANT_FEE = 'CARD_LONG_DORMANT_FEE',
  CARD_FROZEN_FEE = 'CARD_FROZEN_FEE',
  CARD_INTEREST = 'CARD_INTEREST',
  CARD_DISPUTE_HANDLING_FEE = 'CARD_DISPUTE_HANDLING_FEE',
  CARD_DOCUMENT_REQUEST_FEE = 'CARD_DOCUMENT_REQUEST_FEE',
  CARD_SALES_DRAFT_RETRIEVAL_FEE = 'CARD_SALES_DRAFT_RETRIEVAL_FEE',
  CARD_MONTHLY_FEE = 'CARD_MONTHLY_FEE',
  CARD_BIN_ANNUAL_FEE = 'CARD_BIN_ANNUAL_FEE',
  CARD_ISSUANCE_FEE = 'CARD_ISSUANCE_FEE',
  CARD_ARBITRATION_HANDLING_FEE = 'CARD_ARBITRATION_HANDLING_FEE'
}

enum CardTransactionIntent {
  CARD_INTERNAL_ATM_REBATE = 'CARD_INTERNAL_ATM_REBATE',
  CARD_INTERNAL_LOCAL_ATM = 'CARD_INTERNAL_LOCAL_ATM',
  CARD_INTERNAL_OVERSEA_ATM = 'CARD_INTERNAL_OVERSEA_ATM',
  CARD_OVERSEA_ATM_CASHBACK = 'CARD_OVERSEA_ATM_CASHBACK',
  CARD_INTERNAL_CROSS_BORDER_FEE = 'CARD_INTERNAL_CROSS_BORDER_FEE',
  CARD_INTERNAL_CROSS_BORDER_FEE_REBATE = 'CARD_INTERNAL_CROSS_BORDER_FEE_REBATE',
  CARD_INTERNAL_CUPD_CROSS_BORDER_FEE_REBATE = 'CARD_INTERNAL_CUPD_CROSS_BORDER_FEE_REBATE',
  CARD_CROSS_BORDER_FEE_CASHBACK = 'CARD_CROSS_BORDER_FEE_CASHBACK',
  CARD_INTERNAL_FX_MARKUP = 'CARD_INTERNAL_FX_MARKUP',
  CARD_INTERNAL_FX_MARKUP_REBATE = 'CARD_INTERNAL_FX_MARKUP_REBATE',
  CARD_INTERNAL_ONLINE_SMALL_TRANSACTION_FEE = 'CARD_INTERNAL_ONLINE_SMALL_TRANSACTION_FEE',
  CARD_INTERNAL_REFUND_FEE = 'CARD_INTERNAL_REFUND_FEE',
  CARD_INTERNAL_AUTHORIZATION_FAILURE_FEE = 'CARD_INTERNAL_AUTHORIZATION_FAILURE_FEE',
  CARD_CASHBACK = 'CARD_CASHBACK'
}

enum CreditTransactionIntent {
  // CUPD Borrow transcation
  BORROW = 'BORROW',
  // CUPD Repayment Record
  REPAY = 'REPAY',

  /**
   * CUPD REFUND
   */
  REFUND = 'REFUND',

  /***
   * CUPD FEE
   */
  FEE = 'FEE',

  // CUPD FEE
  OTHERS = 'OTHERS',

  // NON CUPD FEE (WITH CARD_ PREFIX)
  CARD_ANNUAL_FEE = 'CARD_ANNUAL_FEE',
  CARD_REPAY = 'CARD_REPAY',
  CASHBACK = 'CARD_CASHBACK',
  INTEREST = 'CARD_INTEREST',
  TOPUP = 'CARD_TOPUP',
  WITHDRAW = 'CARD_WITHDRAW',
  BALANCE_TRANSFER = 'CARD_BALANCE_TRANSFER',
  ADJUSTMENT = 'CARD_ADJUSTMENT',
  CARD_BORROW = 'CARD_BORROW',

  // NON CUPD FEE (INVISIBLE TO CLIENT)
  INTERNAL_REPAY = 'CARD_INTERNAL_REPAY'
}

/**
 * Price in fee intent
 */
enum PriceInFeeIntent {
  PRECIOUS_METAL_BUY_MARKUP = 'PRECIOUS_METAL_BUY_MARKUP',
  PRECIOUS_METAL_SELL_MARKUP = 'PRECIOUS_METAL_SELL_MARKUP'
}

const GENERAL_INSTRUCTION_CREATE_INTENT_OPTIONS = Object.keys(GeneralInstructionIntent).filter(
  (item) =>
    ![
      GeneralInstructionIntent.PRECIOUS_METAL_BUY,
      GeneralInstructionIntent.PRECIOUS_METAL_SELL,
      GeneralInstructionIntent.PRECIOUS_METAL_WITHDRAWAL,
      GeneralInstructionIntent.SCHEDULER,
      GeneralInstructionIntent.ACCOUNT_ADMIN_FEE_REBATE
    ].includes(item as GeneralInstructionIntent)
);

const GENERAL_INSTRUCTION_CREATE_INTENT_OPTIONS_WITHOUT_BILL_PAYMENT =
  GENERAL_INSTRUCTION_CREATE_INTENT_OPTIONS.filter(
    (item) => item !== GeneralInstructionIntent.BILL_PAYMENT
  );

type ExchangeIntent = TransferIntent.REPAYMENT_EXCHANGE | TransferIntent.EXCHANGE;

type CardFeeIntent = CardAccountIntent | CardTransactionIntent;
type CreditTransactionIntentGroup = CreditTransactionIntent | CardAccountIntent | CardTransactionIntent;

export {
  CardAccountIntent,
  type CardFeeIntent,
  CardTransactionIntent,
  CreditTransactionIntent,
  type CreditTransactionIntentGroup,
  type ExchangeIntent,
  GeneralInstructionIntent,
  GENERAL_INSTRUCTION_CREATE_INTENT_OPTIONS,
  GENERAL_INSTRUCTION_CREATE_INTENT_OPTIONS_WITHOUT_BILL_PAYMENT,
  TransferIntent,
  TrustServiceIntent,
  PriceInFeeIntent
};
